module.exports = __webpack_public_path__ + "img/CAD.536c5a11.svg";